import { useMemo } from 'react';

const useIsDomAvailable = () => {
  const value = typeof document !== 'undefined';
  return useMemo(() => value, [value]);
};

export default useIsDomAvailable;
